import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WhiteboardLanding.css';

function WhiteboardLanding() {
    const navigate = useNavigate();

    const handleCreateNew = () => {
        navigate('/whiteboard');
    };

    const handleJoinSession = () => {
        const sessionId = prompt('Enter the Session ID you want to join:');
        if (sessionId && sessionId.trim()) {
            navigate(`/join-whiteboard/${sessionId.trim()}`);
        }
    };

    return (
        <div className="whiteboard-landing">
            <div className="landing-container">
                <div className="landing-header">
                    <h1>🎨 Collaborative Whiteboard</h1>
                    <p>Draw, share, and collaborate in real-time with others</p>
                </div>

                <div className="landing-options">
                    <div className="option-card">
                        <div className="option-icon">🆕</div>
                        <h3>Create New Whiteboard</h3>
                        <p>Start a new whiteboard session and invite others to join</p>
                        <button 
                            className="option-button primary"
                            onClick={handleCreateNew}
                        >
                            Create New Session
                        </button>
                    </div>

                    <div className="option-card">
                        <div className="option-icon">🔗</div>
                        <h3>Join Existing Session</h3>
                        <p>Enter a session ID to join an existing whiteboard</p>
                        <button 
                            className="option-button secondary"
                            onClick={handleJoinSession}
                        >
                            Join Session
                        </button>
                    </div>
                </div>

                <div className="landing-info">
                    <h3>How to Join a Whiteboard Session:</h3>
                    <div className="info-methods">
                        <div className="method">
                            <h4>📧 Via Invite Link</h4>
                            <p>Click on the invite link shared by the host</p>
                            <code>https://yoursite.com/join-whiteboard/session-id</code>
                        </div>
                        
                        <div className="method">
                            <h4>🔢 Via Session ID</h4>
                            <p>Enter the session ID manually:</p>
                            <ol>
                                <li>Click "Join Session" above</li>
                                <li>Enter the session ID (e.g., "1234567890-abcdef12")</li>
                                <li>Enter your name (optional)</li>
                                <li>Start collaborating!</li>
                            </ol>
                        </div>

                        <div className="method">
                            <h4>📱 Via QR Code</h4>
                            <p>Scan the QR code shared by the host with your mobile device</p>
                        </div>
                    </div>
                </div>

                <div className="landing-features">
                    <h3>Features:</h3>
                    <div className="features-grid">
                        <div className="feature">✏️ Real-time drawing</div>
                        <div className="feature">👥 Multi-user collaboration</div>
                        <div className="feature">🎨 Multiple tools & colors</div>
                        <div className="feature">💾 Save & export drawings</div>
                        <div className="feature">📱 Mobile & tablet support</div>
                        <div className="feature">🤖 AI drawing assistant</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhiteboardLanding; 